<template>
	<div id="body" v-if="show">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft animated animated" ata-wow-delay="0.4s" style="visibility: visible; animation-name: bounceInLeft;">
							<h1>{{home}}</h1>
						</div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight animated animated" ata-wow-delay="0.4s" style="visibility: visible; animation-name: bounceInRight;">
							<li>
								<router-link to="/index">{{lang == 1 ? '首页' : 'Home'}}</router-link>
							</li>
							<li class="active">
								<router-link to="/join_us">{{home}}</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<div id="content">
			<section class="blog-section">
				<div class="container">
					<div class="row">
						<!--Blog Section-->
						<div class="col-md-12 col-xs-12">
							<article id="post-2" class="post-content-area wow fadeInDown animated post-2 page type-page status-publish hentry" data-wow-delay="0.4s">
								<div class="blog-featured-img"></div>
								<div class="post-content">
									<div class="entry-content" v-html="article.content"></div>
								</div>
							</article>
						</div>
						<!--/Blog Section-->
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import { getArticle, getArticleDetail } from '../api/api';
	export default {
		data() {
			return {
				show: false,
				baseUrl: 'http://admin.brlsea.org',
				article: '',
				home: ''
			};
		},
		props: ['lang'],
		methods: {
			onGetData() {
				let that = this;
				getArticle({
					lang: this.lang,
					category: 2,
				}).then(res => {
					if(res.code == 1) {
						getArticleDetail({
							lang: that.lang,
							article_id: res.data[0].article_id,
						}).then(res2 => {
							if(res.code == 1) {
								that.article = res2.data;
								that.show = true;
							}
						})
					}
				});
			}
		},
		created() {
			this.onGetData();
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
		}
	};
</script>

<style scoped="scoped">

</style>


// WEBPACK FOOTER //
// src/components/join_us.vue